import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useTheme } from '../context/ThemeContext';
import { ArrowLeft, Plus, List } from 'lucide-react';
import TicketDesignerPage from './TicketDesignerPage';
import TicketDesignerListPage from './TicketDesignerListPage';

const TicketDesignerMainPage = () => {
  const navigate = useNavigate();
  const { isDark } = useTheme();
  const [searchParams] = useSearchParams();
  const editId = searchParams.get('edit');
  
  const [activeTab, setActiveTab] = useState(editId ? 'crear' : 'crear'); // Si hay editId, ir a crear para editar

  useEffect(() => {
    if (editId) {
      setActiveTab('crear');
    }
  }, [editId]);

  return (
    <div className={`min-h-screen ${isDark ? 'bg-gray-900' : 'bg-gray-100'}`}>
      {/* Header */}
      <header className={`${isDark ? 'bg-gray-800 border-b border-gray-700' : 'bg-white'} shadow-sm`}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <button
                onClick={() => navigate('/dashboard')}
                className={`p-2 rounded-lg ${
                  isDark ? 'hover:bg-gray-700 text-gray-300' : 'hover:bg-gray-100 text-gray-700'
                }`}
              >
                <ArrowLeft className="w-5 h-5" />
              </button>
              <div>
                <h1 className={`text-2xl font-bold ${isDark ? 'text-white' : 'text-gray-900'}`}>
                  Editor de Ficha
                </h1>
                <p className={`text-sm ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>
                  Diseña cómo se verán tus vouchers para impresión carta o térmica
                </p>
              </div>
            </div>

            {/* Tabs */}
            <div className="flex gap-2">
              <button
                onClick={() => setActiveTab('crear')}
                className={`flex items-center gap-2 px-6 py-2 rounded-lg font-medium transition-all ${
                  activeTab === 'crear'
                    ? 'bg-blue-600 text-white shadow-lg'
                    : isDark
                      ? 'bg-gray-700 text-gray-300 hover:bg-gray-600'
                      : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                }`}
              >
                <Plus className="w-4 h-4" />
                Crear Diseño
              </button>
              <button
                onClick={() => setActiveTab('listar')}
                className={`flex items-center gap-2 px-6 py-2 rounded-lg font-medium transition-all ${
                  activeTab === 'listar'
                    ? 'bg-blue-600 text-white shadow-lg'
                    : isDark
                      ? 'bg-gray-700 text-gray-300 hover:bg-gray-600'
                      : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                }`}
              >
                <List className="w-4 h-4" />
                Ver Diseños
              </button>
            </div>
          </div>
        </div>
      </header>

      {/* Contenido según tab activo */}
      {activeTab === 'crear' ? (
        <TicketDesignerPage isEmbedded={true} editTemplateId={editId} />
      ) : (
        <TicketDesignerListPage onEdit={() => setActiveTab('crear')} />
      )}
    </div>
  );
};

export default TicketDesignerMainPage;
